import axios from '@/components/api/axios';

async function bcList() {
  const res = await axios.axiosGet('api/bcs/getBcNoList', null);
  return res;
}

export default {
  bcList
}



// WEBPACK FOOTER //
// ./src/components/api/bc.js